/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreOpsChecklist
 */
export interface PreOpsChecklist {
    /**
     * 
     * @type {string}
     * @memberof PreOpsChecklist
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof PreOpsChecklist
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PreOpsChecklist
     */
    updatedAt: Date;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsChecklist
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof PreOpsChecklist
     */
    label: string;
    /**
     * The time a driver has to complete this checklist before being logged out. `None` disables the timer.
     * @type {number}
     * @memberof PreOpsChecklist
     */
    minutesUntilLogout?: number | null;
}

/**
 * Check if a given object implements the PreOpsChecklist interface.
 */
export function instanceOfPreOpsChecklist(value: object): value is PreOpsChecklist {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function PreOpsChecklistFromJSON(json: any): PreOpsChecklist {
    return PreOpsChecklistFromJSONTyped(json, false);
}

export function PreOpsChecklistFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsChecklist {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'deleted': json['deleted'],
        'label': json['label'],
        'minutesUntilLogout': json['minutesUntilLogout'] == null ? undefined : json['minutesUntilLogout'],
    };
}

export function PreOpsChecklistToJSON(json: any): PreOpsChecklist {
    return PreOpsChecklistToJSONTyped(json, false);
}

export function PreOpsChecklistToJSONTyped(value?: PreOpsChecklist | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'deleted': value['deleted'],
        'label': value['label'],
        'minutesUntilLogout': value['minutesUntilLogout'],
    };
}

